import { Directive } from '@angular/core';
import { AbstractControlOptions, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

@Directive()
export abstract class PrPmeFormBuilder extends PrFormAbstract {
  getDuration() {
    let date =
      (new Date(this.form.value.endDate).getFullYear() -
        new Date(this.form.value.startDate).getFullYear()) *
      12;
    return date;
  }

  generate(entity: any) {
    if (entity.id && !entity.type) {
      entity.type = 'PME';
    }

    let options: AbstractControlOptions = {};

    let form = this.formBuilder.group(
      {
        id: [entity ? entity.id : null],
        type: [entity ? entity.type : null, Validators.required],
        label: [entity ? entity.label : null, Validators.required],
        owners: [this.buildInitialOwners(entity), Validators.required],
        purchasePrice: [
          entity ? entity.purchasePrice : null,
          Validators.required,
        ],
        lastValue: [entity ? entity.lastValue : null, Validators.required],
        pmeAllowDefiscalisation: [
          entity &&
          entity.pmeAllowDefiscalisation != null &&
          entity.pmeAllowDefiscalisation != undefined
            ? entity.pmeAllowDefiscalisation
            : true,
          this.prFormService.RefreshEveryValidators(),
        ],
        taxReductionRate: [
          entity.taxReductionRate
            ? Math.round(entity.taxReductionRate * 100 * 100) / 100
            : null,
          this.prFormService.AddValidatorsBasedOnCondition(
            this.prFormService
              .isTargetControlValueEqualTo(
                'pmeAllowDefiscalisation',
                val => val,
              )
              .bind(this),
            Validators.required,
          ),
        ],

        duration: [entity ? entity.duration / 12 : null, Validators.required],
        startDate: [entity ? entity.startDate : null, Validators.required],
        endDate: [entity ? entity.endDate : null],
        contratId: [entity ? entity.contratId : null, Validators.required],
        subscriptionSource: [
          entity ? entity.subscriptionSource : null,
          Validators.required,
        ],
        accountId: [entity ? entity.accountId : null, Validators.required],
        userId: [entity ? entity.userId : null, Validators.required],
        subscriptionId: [entity ? entity.subscriptionId : null],
      },
      options,
    );

    return form;
  }

  extract() {
    let dto: any = {
      id: this.emptyIsNull(this.form.value.id),
      owners: this.form.value.owners,
      type: this.emptyIsNull(this.form.value.type),
      label: this.emptyIsNull(this.form.value.label),
      purchasePrice: this.emptyIsNull(this.form.value.purchasePrice),
      lastValue: this.emptyIsNull(this.form.value.lastValue),
      pmeAllowDefiscalisation: this.emptyIsNull(
        this.form.value.pmeAllowDefiscalisation,
      ),
      taxReductionRate: !!this.form.value.pmeAllowDefiscalisation
        ? this.emptyIsNull(
            this.form.value.taxReductionRate
              ? this.form.value.taxReductionRate / 100
              : null,
          )
        : null,
      duration: this.emptyIsNull(
        this.form.value.endDate
          ? this.getDuration()
          : this.form.value.duration * 12,
      ),
      startDate:
        new Date(this.form.value.startDate).toISOString().split('.')[0] + 'Z',
      endDate: this.form.value.endDate
        ? new Date(this.form.value.endDate).toISOString().split('.')[0] + 'Z'
        : null,
      contratId: this.emptyIsNull(
        this.form.value.contratId.name
          ? this.form.value.contratId.name
          : this.form.value.contratId,
      ),
      subscriptionSource: this.emptyIsNull(this.form.value.subscriptionSource),
      accountId: this.emptyIsNull(this.form.value.accountId),
      userId: this.emptyIsNull(this.form.value.userId),
      subscriptionId: this.emptyIsNull(this.form.value.subscriptionId),
    };
    return dto;
  }
}
